const removeWidgetsForAddMode = ({ schema, tabs }) => {
  if (tabs != null && !Array.isArray(tabs)) {
    throw new Error('tabs must be array')
  }

  Object.keys(schema).forEach((key) => {
    if (
      [
        'child-entity-data',
        'multi-ref',
        'function',
        'pdfGenerator',
        'attachment',
        'sequence'
      ].includes(schema[key].type)
    ) {
      // TODO: Trebuie sa modificam si tabs headers corespunzator
      if (tabs != null) {
        const widgetTab = getWidgetTabIndex({ schema, widget: key })
        const aloneInTab = isWidgetAloneInTab({ schema, widget: key })
        console.log(
          `Widget ${key} found on tab ${widgetTab} alone ${aloneInTab}`
        )
        if (widgetTab != null && aloneInTab) {
          console.log('Remove tab: ' + tabs[widgetTab])
          tabs.splice(widgetTab, 1)
        }
      }
      delete schema[key]
    }
  })
}

const isWidgetAloneInTab = ({ schema, widget }) => {
  // cazuri pozitive:
  // este pe tabul 0 are tabSplitAfter specificat si nu are niciun widget inainte de el
  // este pe tabul k (k != 0, k != n - 1), widget-ul dinainte are tabsplitafter si el are tabsplitafter
  // este pe tabul n-1 si widget-ul dinainte are tabSplitAfter
  if (schema == null) {
    throw new Error('Null schema')
  }
  if (widget == null) {
    throw new Error('Null widget')
  }
  if (schema[widget] == null)
    throw new Error(`Widget ${widget} not in schema ${schema}`)
  if (Object.keys(schema).length === 1) {
    return true
  }
  const widgetTab = getWidgetTabIndex({ schema, widget })
  if (widgetTab == null) throw new Error('Widget not in schema')
  let widgetIndex = Object.keys(schema).indexOf(widget)
  let widgetBefore =
    widgetIndex <= 0 ? null : schema[Object.keys(schema)[widgetIndex - 1]]

  let lastWidget = Object.keys(schema)[Object.keys(schema).length - 1]

  return (
    (widgetTab === 0 &&
      widgetBefore == null &&
      schema[widget].tabSplitAfter === true) ||
    (widget === lastWidget &&
      widgetBefore != null &&
      widgetBefore.tabSplitAfter === true) ||
    (schema[widget].tabSplitAfter === true &&
      widgetBefore != null &&
      widgetBefore.tabSplitAfter === true)
  )
}

const getWidgetTabIndex = ({ schema, widget }) => {
  if (schema == null || widget == null || schema[widget] == null) {
    return null
  }
  let index = 0
  let found = false
  Object.keys(schema).forEach((key) => {
    if (found) {
      return
    }
    if (key === widget) {
      found = true
    } else if (schema[key].tabSplitAfter === true) {
      index++
    }
  })
  return found ? index : null
}

export { isWidgetAloneInTab, getWidgetTabIndex, removeWidgetsForAddMode }
